import ReplySubmissionForm from '../../components/pages/received_gifts/ReplySubmissionForm.vue'

export default {
  components: {
    ReplySubmissionForm
  }
}
